var map = {
	"./Canada/amazonFinds.json": 234,
	"./Canada/babyshowers.json": 1,
	"./Canada/birthday.json": 119,
	"./Canada/christmas.json": 602,
	"./Canada/farewell.json": 2,
	"./Canada/home.json": 565,
	"./Canada/housewarming.json": 601,
	"./Canada/occasions.json": 594,
	"./Canada/personalized.json": 388,
	"./Canada/thanksgiving.json": 689,
	"./Canada/topOccasions.json": 703,
	"./Canada/uniqueGifts.json": 864,
	"./Canada/valentines.json": 677,
	"./Canada/wedding.json": 170,
	"./India/diwali.json": 500,
	"./India/home.json": 488,
	"./India/occasions.json": 29,
	"./India/topOccasions.json": 222,
	"./USA/birthday.json": 442,
	"./USA/christmas.json": 469,
	"./USA/home.json": 892,
	"./USA/housewarming.json": 623,
	"./USA/occasions.json": 25,
	"./USA/thanksgiving.json": 560,
	"./USA/topOccasions.json": 482,
	"./USA/wedding.json": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;